module.exports = __webpack_public_path__ + "img/icon-remove.fac527e4.svg";